(function ($) {
if (!customElements.get('cdz-product-gallery')) {
  customElements.define('cdz-product-gallery', class CdzProductForm extends HTMLElement {
    options = {};
    constructor() {
      super();
      this.element = $(this);
      this.options = $.extend(this.options, this.dataset)
      this.$viewer = $('[data-role="gallery-main"]', this.element);
      this.$thumbs = $('[data-role="gallery-thumbs"]', this.element).removeClass('hidden');
      this.buildSlider();
    }
    buildSlider() {
      var self = this, conf = this.options;
      if (conf.dir == 'ver') {
        var thumDir = 'vertical', slidesPerView = 'auto';
      } else {
        var thumDir = 'horizontal', slidesPerView = conf.thumbsperview;
      }
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      };
      this.thumbnails = new Swiper(this.$thumbs.get(0), {
        loop: false,
        spaceBetween: parseInt(conf.thumbsgap),
        slidesPerView: slidesPerView,
        freeMode: true,
        watchSlidesProgress: true,
        direction: thumDir,
        navigation: {
          nextEl: ".btn-thumb-next",
          prevEl: ".btn-thumb-prev"
        }
      });
      this.viewer = new Swiper(this.$viewer.get(0), {
        loop: false,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        thumbs: {
          swiper: self.thumbnails
        },
        pagination: { el: ".swiper-pagination", clickable: true }
      });
      this.viewer.on('slideChange', () => {
        var activeMedia = self.viewer.slides[self.viewer.activeIndex];
        self.$viewer.trigger('slideChanged', [activeMedia]);
      });
      self.$viewer.on('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
    }
    onSlideChanged(event, activeMedia) {
      this.setActiveMedia($(activeMedia).attr('data-media-id'));
    }
    setActiveMedia(mediaId, prepend) {
      var self = this;
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      if (prepend) {
        this.$viewer.find('.swiper-slide-active').removeClass('swiper-slide-active');
        var slideId = Array.prototype.indexOf.call(activeMedia.parentNode.childNodes, activeMedia);
        this.viewer.slideTo(slideId, 0, false);
      }
      this.playActiveMedia(activeMedia);
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }
    setActiveThumbnail(thumbnail) {}
    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }
    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }
    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
})(jQuery);